export default "__VITE_ASSET__DK$g2RWp__"